<template>
    <form action="/checkout" method="POST" ref="form">
        <input type="hidden" name="payment_method" :value="selectedNewPaymentMethod" />
        <input type="hidden" name="_token" :value="csrf" />
    </form>
</template>

<script>
export default {
    mounted() {
        this.csrf = window.meta.csrf;
    },
    data: () => ({
        csrf: null
    }),
    props: {
        selectedNewPaymentMethod: String
    },
    methods: {
        submit() {
            this.$refs.form.submit();
        }
    }
};
</script>
